import { render, staticRenderFns } from "./CandidateAnswersComponent.vue?vue&type=template&id=cf57d18e&"
import script from "./CandidateAnswersComponent.vue?vue&type=script&lang=js&"
export * from "./CandidateAnswersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports